import React, {useState} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {Action} from '../../../system/buttons';
import Ranges from '../../../system/ranges';
import ColorPicker from './ColorPicker';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';

export const ResidentEvilEdit = (props) => {
  const [configuration, setConfiguration] = useState(props.configuration);

  const updateConfiguration = (configPart) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  return (
    <>
      <h4>Configured ranges</h4>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <Ranges
          ranges={configuration.ranges}
          onRangesChange={(ranges) => updateConfiguration({ranges})}
          defaultRange={{
            from: 60,
            to: 90,
            color: '#32ff00ff',
            text: 'Fine',
          }}
          header={
            <>
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
              <Col md={3}>
                <Form inline>
                  <Col>Text</Col>
                </Form>
              </Col>
              <Col md={3}>
                <Form inline>
                  <Col>Speed</Col>
                </Form>
              </Col>
            </>
          }
          rangeConfiguration={(range, onRangeChange) => (
            <>
              <Col md={2}>
                <Form inline>
                  <ColorPicker
                    color={range.color}
                    onChangeComplete={(color) =>
                      onRangeChange({...range, color})
                    }
                  />
                </Form>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="text"
                  value={range.text}
                  onChange={(e) =>
                    onRangeChange({...range, text: e.target.value})
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Control
                  as="select"
                  value={range.speed}
                  onChange={(e) =>
                    onRangeChange({...range, speed: Number(e.target.value)})
                  }
                >
                  <option value={0}>Very Slow</option>
                  <option value={1}>Slow</option>
                  <option value={2}>Normal</option>
                  <option value={3}>Fast</option>
                  <option value={4}>Very fast</option>
                </Form.Control>
              </Col>
            </>
          )}
        />
      </PremiumWrapperOverlay>
      <Row>&nbsp;</Row>
      <Action onClick={() => props.onSave({ranges: configuration.ranges})}>
        Save settings
      </Action>
    </>
  );
};
